import React, { useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
import { Menu, MenuItem } from '@blueprintjs/core';
import { Button, Popover, Icons, TextInput } from '../';
export const Dropdown = ({ label, width = 280, // control the width of the dropdown
searchItems, updateSelection, selectedItem, placeholderValue, disabled, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    let canSearch = false;
    const showPlaceholder = placeholderValue && !selectedItem;
    if (!selectedItem) {
        selectedItem = { key: '', label: '' };
    }
    if (searchItems.length >= 20) {
        canSearch = true;
    }
    const searchedItems = searchItems.filter(({ label }) => typeof label === 'string' ? label.toLowerCase().includes(searchValue.toLowerCase()) : false);
    const row = ({ index, style }) => {
        const item = searchedItems[index];
        const isSelected = selectedItem ? selectedItem.key === item.key : false;
        const { key, label, icon, fill, className } = item;
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                updateSelection(item);
                setIsOpen(false);
            }
        };
        const createdIcon = (React.createElement(Icons, { iconName: `ic-${icon}`, fill: fill, title: icon, className: cx(icon, className), size: 24 }));
        return (React.createElement("div", { style: style },
            React.createElement(MenuItem, { className: cx('dropdown_item', {
                    'dropdown_item--selected': isSelected,
                    'dropdown_item--empty': key === 'NullValue' || key === '',
                }), key: `dropdown-item-${key}`, text: label, icon: icon ? createdIcon : undefined, shouldDismissPopover: true, onClick: () => updateSelection(item), onKeyPress: selectItemOnKeyPress, tabIndex: 0 })));
    };
    const createDropdownMenu = () => {
        const itemCount = searchedItems.length;
        const listHeight = itemCount < 10 ? itemCount * 40 : 300;
        return (React.createElement(Menu, null,
            React.createElement(List, { height: listHeight, width: width, itemSize: 40, itemCount: itemCount }, row)));
    };
    const handlePopoverToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    const setSearchOnChange = (e) => setSearchValue(e.target.value);
    const getIcon = (icon, className) => (React.createElement(Icons, { iconName: `ic-${icon}`, title: icon, className: cx(icon, className), size: 24 }));
    return (React.createElement("div", { className: "dropdown" },
        label && React.createElement("h6", { className: "dropdown_label" }, label),
        React.createElement(Popover, { modifiers: {
                arrow: { enabled: false },
                preventOverflow: { boundariesElement: 'viewport' },
            }, popoverClassName: "dropdown_popover", position: "bottom-left", transitionDuration: 0, isOpen: isOpen, canEscapeKeyClose: false, onInteraction: disabled ? () => { } : handlePopoverToggle, onClose: () => setIsOpen(false), autoFocus: false },
            React.createElement(Button, { className: cx('dropdown_button', { 'dropdown_button--open': isOpen }), style: "subtle", disabled: disabled, "aria-label": label, rightIcon: React.createElement(Icons, { iconName: "ic-ui-chevron-down", className: "dropdown_button--chevron" }) },
                React.createElement("div", { className: "dropdown_wrap" }, showPlaceholder ? (React.createElement("span", { className: "dropdown_button--item dropdown_button--placeholder" }, placeholderValue)) : (React.createElement(React.Fragment, null,
                    selectedItem.icon && getIcon(selectedItem.icon, selectedItem.className),
                    React.createElement("span", { className: "dropdown_button--item" }, selectedItem.label))))),
            React.createElement("div", { className: "dropdown_content" },
                canSearch && (React.createElement("div", { className: "dropdown_search" },
                    React.createElement(TextInput, { icon: React.createElement(Icons, { iconName: "ic-ui-search", className: "ic-ui-search" }), value: searchValue, onChange: setSearchOnChange, placeholder: 'Search', autoFocus: true }))),
                createDropdownMenu()))));
};
//# sourceMappingURL=Dropdown.js.map